const BRANDS = [
  { name: "Make", src: "/brands/make.png" },
  { name: "Virulana", src: "/brands/virulana.png" },
  { name: "Laffitte Detail", src: "/brands/laffitte.png" },
  { name: "Lumilagro", src: "/brands/lumilagro.png" },
  { name: "Iluminarte", src: "/brands/iluminarte.png" },
  { name: "Mapuche", src: "/brands/mapuche.png" },
  { name: "Textil Duramás", src: "/brands/duramas.png" },
  { name: "Mister Trapo", src: "/brands/mistertrapo.png" },
  { name: "Plásticos Florida", src: "/brands/florida.png" },
  { name: "Durax", src: "/brands/durax.png" },
  { name: "Algabo", src: "/brands/algabo.png" },
  { name: "Colores", src: "/brands/colores.png" },
  { name: "La Gauchita", src: "/brands/lagauchita.png" },
  { name: "Hudson", src: "/brands/hudson.png" },
  { name: "Magiclick", src: "/brands/magiclick.png" },
  { name: "Bel Gioco", src: "/brands/belgioco.png" },
  { name: "Atom", src: "/brands/atom.png" },
  { name: "Fibran", src: "/brands/fibran.png" },
  { name: "Xper", src: "/brands/xper.png" },
  { name: "Estilo Spa", src: "/brands/estilospa.png" },
];

// Duplicamos la lista para que el loop se vea infinito sin "saltos"
const TRACK = [...BRANDS, ...BRANDS];

const Brands = () => (
  <section className="bg-slate-50 border-y border-slate-200 overflow-hidden" data-testid="brands-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-center mb-10">
        <span className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">Marcas que confían en nosotros</span>
        <h2 className="font-heading font-extrabold text-3xl md:text-4xl tracking-tight mt-2">Trabajamos con las mejores marcas</h2>
        <p className="text-slate-500 text-sm md:text-base mt-2 max-w-xl mx-auto">
          Productos originales de las marcas líderes del mercado argentino en limpieza, bazar y perfumería.
        </p>
      </div>
    </div>

    {/* Auto-scroll marquee */}
    <div className="relative w-full overflow-hidden pb-14 marquee-mask">
      <div className="brand-track flex gap-5 w-max">
        {TRACK.map((b, i) => (
          <div
            key={`${b.name}-${i}`}
            className="bg-white rounded-2xl border border-slate-200 px-6 py-4 flex items-center justify-center shrink-0 w-44 h-28 shadow-sm hover:shadow-md hover:-translate-y-1 hover:border-blue-300 transition-all"
            data-testid={`brand-${b.name}`}
            title={b.name}
          >
            <img
              src={b.src}
              alt={b.name}
              className="max-h-full max-w-full object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>

    <style>{`
      @keyframes brand-scroll {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      .brand-track {
        animation: brand-scroll 60s linear infinite;
      }
      .brand-track:hover {
        animation-play-state: paused;
      }
      .marquee-mask {
        mask-image: linear-gradient(to right, transparent 0%, black 6%, black 94%, transparent 100%);
        -webkit-mask-image: linear-gradient(to right, transparent 0%, black 6%, black 94%, transparent 100%);
      }
      @media (prefers-reduced-motion: reduce) {
        .brand-track { animation: none; }
      }
    `}</style>
  </section>
);

export default Brands;
